var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45013 5.73842C7.93771 4.97453 7.27306 4.79019 6.67976 5.24685L4.37998 7.01484C2.94873 8.11529 2 10.9265 2 14.0672C2 15.771 2.9963 16.6382 3.59231 15.4526C4.39833 13.848 5.35861 12.6079 6.412 11.8133L8.12868 10.5173C9.1277 9.76317 9.31187 7.02182 8.45013 5.73842Z",
    fill: "#EBE298"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 8.83594C10.1953 9.22426 10.5101 9.53906 10.8984 9.53906H21.5391C21.9274 9.53906 22.2422 9.22426 22.2422 8.83594C22.2422 8.44761 21.9274 8.13281 21.5391 8.13281H10.8984C10.5101 8.13281 10.1953 8.44761 10.1953 8.83594Z",
    fill: "#3ABBC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 12.0547C10.1953 12.443 10.5101 12.7578 10.8984 12.7578H21.5391C21.9274 12.7578 22.2422 12.443 22.2422 12.0547C22.2422 11.6664 21.9274 11.3516 21.5391 11.3516H10.8984C10.5101 11.3516 10.1953 11.6664 10.1953 12.0547Z",
    fill: "#3ABBC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78906 10.2422C8.78906 12.1838 7.21505 13.7578 5.27344 13.7578C3.33183 13.7578 1.75781 12.1838 1.75781 10.2422C1.75781 8.30058 3.33183 6.72656 5.27344 6.72656C7.21505 6.72656 8.78906 8.30058 8.78906 10.2422Z",
    stroke: "#3E4E56",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5372 9.86034C6.53734 9.86034 5.68947 8.70061 5.27327 8.13281C4.85702 8.70061 4.00919 9.86034 4.00919 9.86034C3.81934 10.1195 3.70703 10.4393 3.70703 10.7853C3.70703 11.6503 4.40828 12.3516 5.27327 12.3516C6.1383 12.3516 6.8395 11.6503 6.8395 10.7853C6.8395 10.4393 6.72723 10.1195 6.5372 9.86034Z",
    stroke: "#3E4E56",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 14.4609V6.02344C0.351562 5.24681 0.981187 4.61719 1.75781 4.61719H22.2422C23.0188 4.61719 23.6484 5.24681 23.6484 6.02344V17.9766C23.6484 18.7532 23.0188 19.3828 22.2422 19.3828H1.75781C0.981187 19.3828 0.351562 18.7532 0.351562 17.9766V15.8672H23.6484",
    stroke: "#3E4E56",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrRange);
export default __webpack_public_path__ + "static/media/hr-range.2db19d59622e350f3827b5b7441c0e16.svg";
export { ForwardRef as ReactComponent };